import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=7061d04f"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"
import style0 from "./NewsLetter.vue?vue&type=style&index=0&id=7061d04f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports